import React from 'react';

const types = {
    nome_completo: {
        regex: /^.{2,}$/,
        message: 'Digite o Nome Completo.'
    },
    rg: {
        regex: /^(^\d{1,2}).?(\d{3}).?(\d{3})-?(\d{1}|X|x$)$/,
        message: 'RG inválido.'
    },
    cep: {
        regex: /^\d{5}-?\d{3}$/,
        message: 'CEP inválido.'
    },
    email: {
        regex: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
        message: 'E-mail inválido.'
    },
    telefone_celular: {
        regex: /^(\(?\d{2}\)?\s)?(\d{4,5}-\d{4})$/,
        message: 'Telefone/Celular inválido.'
    },
    date: {
        regex: /^\d{2}\/\d{2}\/\d{4}$/,
        message: 'Data inválida.'
    },
    cnpj_cpf: {
        // eslint-disable-next-line 
        regex: /^([0-9]{2}[\.]?[0-9]{3}[\.]?[0-9]{3}[\/]?[0-9]{4}[-]?[0-9]{2})|([0-9]{3}[\.]?[0-9]{3}[\.]?[0-9]{3}[-]?[0-9]{2})$/,
        message: 'CNPJ/CPF Inválido.'
    },
    cnpj: {
        // eslint-disable-next-line
        regex: /^[0-9]{2}[\.]?[0-9]{3}[\.]?[0-9]{3}[\/]?[0-9]{4}[-]?[0-9]{2}$/,
        message: 'CNPJ Inválido.'
    },
    number: {
        regex: /^\d+$/,
        message: 'Apenas numeros inteiros.'
    },
    password: {
        regex: /^.{1,}$/,
        message: 'A senha deve conter 1 caracteres ou mais.'
    },
    notEmpty: {
        regex: /^.{1,}$/,
        message: 'Preencha esse campo.'
    },
    nameFile: {
        regex: /^[0-9a-zA-Z_]+$/,
        message: 'Retire os caracteres especiais do nome do arquivo.'
    }
};

const useForm = (type?: keyof typeof types) => {

    const [value, setValue] = React.useState('');
    const [error, setError] = React.useState('');

    function validate(value: any) {

        if (type === undefined) return true;

        if (value.length === 0) {
            setError('Esse campo não pode estar vázio.');
            return false;
        } else if (types[type] && !types[type].regex.test(value)) {
            setError(types[type].message);
            return false;
        } else {
            setError('');
            return true;
        }

    }

    function onChange(event: React.ChangeEvent<HTMLInputElement & HTMLSelectElement & HTMLTextAreaElement>) {
        if (error) validate(event.target.value);
        setValue(event.target.value);
    }

    return {
        value,
        error,
        setValue,
        onChange,
        onBlur: () => validate(value),
        validate: () => validate(value),
    }
}

export default useForm;